module.exports = __webpack_public_path__ + "src/assets/images/arrow-right-red.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right-red.webp
// module id = 283
// module chunks = 3